import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, login as apiLogin, signup as apiSignup, setModuleProgress as apiSetProgress } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("fs_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await fetchMe();
      setUser(me);
    } catch (e) {
      localStorage.removeItem("fs_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async ({ email, password }) => {
    const { token, user } = await apiLogin({ email, password });
    localStorage.setItem("fs_token", token);
    setUser(user);
    return user;
  }, []);

  const signup = useCallback(async ({ session_id, password }) => {
    const { token, user } = await apiSignup({ session_id, password });
    localStorage.setItem("fs_token", token);
    setUser(user);
    return user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("fs_token");
    setUser(null);
  }, []);

  const setProgress = useCallback(async ({ module_id, completed }) => {
    const updated = await apiSetProgress({ module_id, completed });
    setUser(updated);
    return updated;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, refresh, setProgress }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
